
export const spotlightCategories = [
  { id: 'all', label: 'All', icon: 'ri-apps-line' },
  { id: 'dining', label: 'Dining', icon: 'ri-restaurant-line' },
  { id: 'wellness', label: 'Wellness', icon: 'ri-heart-pulse-line' },
  { id: 'shopping', label: 'Shopping', icon: 'ri-shopping-bag-line' },
  { id: 'services', label: 'Services', icon: 'ri-tools-line' },
  { id: 'entertainment', label: 'Entertainment', icon: 'ri-movie-2-line' },
];

export const spotlightBusinesses = [
  {
    id: 1,
    name: 'The Monk’s Cellar',
    category: 'dining',
    tagline: 'Craft Brewery & Kitchen',
    description:
      'Award-winning microbrewery in the heart of Old Town Roseville serving house-brewed ales, seasonal IPAs, and elevated pub fare. Their outdoor beer garden is a local favorite for weekend gatherings.',
    address: '340 Vernon St, Roseville, CA 95678',
    phone: '(916) 782-6665',
    hours: 'Tue–Sun 11am–9pm',
    rating: 4.8,
    reviewCount: 487,
    priceRange: '$$',
    image:
      'https://public.readdy.ai/ai/img_res/3912c6d4b6a5484c804358f19f23b898.jpg',
    badge: 'Editor’s Pick',
    badgeColor: 'teal',
    reviews: [
      { author: 'Sarah M.', text: 'Best craft beer in Placer County! The Hazy IPA is incredible and the truffle fries are addictive.', rating: 5, date: '2 weeks ago' },
      { author: 'David K.', text: 'Love the outdoor patio. Great vibe, friendly staff, and the rotating taps always have something new.', rating: 5, date: '1 month ago' },
    ],
    highlights: ['Outdoor Patio', 'Live Music Fri–Sat', 'Dog Friendly'],
  },
  {
    id: 2,
    name: 'Restore Wellness Spa',
    category: 'wellness',
    tagline: 'Holistic Health & Recovery',
    description:
      'A modern wellness sanctuary offering cryotherapy, infrared sauna, IV drip therapy, and therapeutic massage. Designed for athletes, busy professionals, and anyone seeking rejuvenation.',
    address: '1780 Prairie City Rd, Roseville, CA 95661',
    phone: '(916) 899-2200',
    hours: 'Mon–Sat 8am–7pm',
    rating: 4.9,
    reviewCount: 234,
    priceRange: '$$$',
    image:
      'https://readdy.ai/api/search-image?query=luxurious%20modern%20wellness%20spa%20interior%20with%20soft%20warm%20lighting%20clean%20minimalist%20design%20bamboo%20accents%20white%20towels%20rolled%20neatly%20on%20wooden%20shelves%20calming%20zen%20atmosphere%20with%20stone%20water%20feature%20and%20green%20plants%20serene%20treatment%20room&width=640&height=420&seq=spot2&orientation=landscape',
    badge: 'Top Rated',
    badgeColor: 'amber',
    reviews: [
      { author: 'Jennifer L.', text: 'The cryotherapy sessions have been a game-changer for my recovery. Staff is incredibly knowledgeable.', rating: 5, date: '3 days ago' },
      { author: 'Mike R.', text: 'Clean, professional, and relaxing. The infrared sauna is my weekly ritual now. Highly recommend!', rating: 5, date: '2 weeks ago' },
    ],
    highlights: ['Cryotherapy', 'Infrared Sauna', 'IV Therapy'],
  },
  {
    id: 3,
    name: 'Bijou Boutique',
    category: 'shopping',
    tagline: 'Curated Fashion & Gifts',
    description:
      'A charming Old Town boutique featuring locally designed jewelry, sustainable fashion, artisan home goods, and unique gifts. Every piece tells a story and supports independent makers.',
    address: '424 Vernon St, Roseville, CA 95678',
    phone: '(916) 773-4488',
    hours: 'Mon–Sat 10am–6pm, Sun 11am–5pm',
    rating: 4.7,
    reviewCount: 189,
    priceRange: '$$',
    image:
      'https://readdy.ai/api/search-image?query=charming%20boutique%20shop%20interior%20with%20curated%20fashion%20clothing%20on%20wooden%20racks%20handmade%20jewelry%20displayed%20in%20glass%20cases%20warm%20natural%20lighting%20exposed%20brick%20walls%20with%20greenery%20and%20vintage%20decor%20cozy%20retail%20space%20with%20artisan%20goods&width=640&height=420&seq=spot3&orientation=landscape',
    badge: 'Local Favorite',
    badgeColor: 'rose',
    reviews: [
      { author: 'Amanda T.', text: 'Found the most beautiful handmade earrings here! The owner has impeccable taste and is so helpful.', rating: 5, date: '1 week ago' },
      { author: 'Rachel P.', text: 'My go-to for unique gifts. Everything is beautifully curated and you can tell they support local artists.', rating: 4, date: '3 weeks ago' },
    ],
    highlights: ['Local Artisans', 'Sustainable Fashion', 'Gift Wrapping'],
  },
  {
    id: 4,
    name: 'Nixtaco Mexican Kitchen',
    category: 'dining',
    tagline: 'Authentic Mexican Street Food',
    description:
      'James Beard-nominated chef serving elevated Mexican street food with house-made tortillas from heirloom corn. Known for their mole negro, birria tacos, and creative mezcal cocktails.',
    address: '2295 Sunrise Blvd, Roseville, CA 95661',
    phone: '(916) 780-7673',
    hours: 'Wed–Mon 11am–10pm',
    rating: 4.9,
    reviewCount: 612,
    priceRange: '$$',
    image:
      'https://readdy.ai/api/search-image?query=vibrant%20Mexican%20restaurant%20interior%20with%20colorful%20hand%20painted%20tiles%20warm%20terracotta%20walls%20and%20rustic%20wooden%20tables%20beautifully%20plated%20birria%20tacos%20with%20fresh%20garnishes%20on%20a%20ceramic%20plate%20ambient%20warm%20lighting%20festive%20authentic%20atmosphere&width=640&height=420&seq=spot4&orientation=landscape',
    badge: 'Must Try',
    badgeColor: 'orange',
    reviews: [
      { author: 'Carlos G.', text: 'The birria tacos are the best I’ve had outside of Mexico City. Absolutely phenomenal flavors.', rating: 5, date: '5 days ago' },
      { author: 'Lisa W.', text: 'House-made tortillas make all the difference. The mole is complex and deeply satisfying. A gem!', rating: 5, date: '2 weeks ago' },
    ],
    highlights: ['James Beard Nominated', 'House-Made Tortillas', 'Mezcal Bar'],
  },
  {
    id: 5,
    name: 'Roseville Escape Rooms',
    category: 'entertainment',
    tagline: 'Immersive Puzzle Adventures',
    description:
      'Northern California’s top-rated escape room experience with 6 uniquely themed rooms. From haunted mansions to space stations, each room features Hollywood-quality sets and mind-bending puzzles.',
    address: '10013 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 542-7700',
    hours: 'Daily 10am–10pm',
    rating: 4.8,
    reviewCount: 356,
    priceRange: '$$',
    image:
      'https://readdy.ai/api/search-image?query=dramatic%20escape%20room%20interior%20with%20mysterious%20themed%20decor%20dim%20atmospheric%20purple%20and%20amber%20lighting%20intricate%20puzzle%20elements%20on%20walls%20vintage%20maps%20and%20cryptic%20symbols%20immersive%20adventure%20game%20room%20with%20theatrical%20set%20design&width=640&height=420&seq=spot5&orientation=landscape',
    badge: 'Family Fun',
    badgeColor: 'violet',
    reviews: [
      { author: 'Tom H.', text: 'Did the space station room with my kids and we had an absolute blast. Production quality is insane!', rating: 5, date: '1 week ago' },
      { author: 'Priya S.', text: 'Best team-building activity ever. The puzzles are challenging but fair. We’re already booking our next room.', rating: 4, date: '1 month ago' },
    ],
    highlights: ['6 Themed Rooms', 'Team Building', 'Ages 8+'],
  },
  {
    id: 6,
    name: 'Sierra Cycle & Fitness',
    category: 'wellness',
    tagline: 'Bikes, Gear & Community Rides',
    description:
      'Full-service bike shop and cycling community hub. Expert repairs, premium bike sales, professional fittings, and weekly group rides along the Miners Ravine Trail.',
    address: '9500 Greenback Ln, Roseville, CA 95661',
    phone: '(916) 786-2453',
    hours: 'Mon–Sat 9am–6pm, Sun 10am–4pm',
    rating: 4.7,
    reviewCount: 178,
    priceRange: '$$',
    image:
      'https://readdy.ai/api/search-image?query=modern%20bicycle%20shop%20interior%20with%20premium%20road%20bikes%20and%20mountain%20bikes%20displayed%20on%20wall%20racks%20clean%20organized%20retail%20space%20with%20cycling%20gear%20and%20accessories%20bright%20natural%20lighting%20professional%20bike%20workshop%20area%20visible%20in%20background&width=640&height=420&seq=spot6&orientation=landscape',
    badge: 'Community Hub',
    badgeColor: 'emerald',
    reviews: [
      { author: 'Brian F.', text: 'Got my road bike fitted here and the difference is night and day. Incredibly knowledgeable staff.', rating: 5, date: '4 days ago' },
      { author: 'Kathy N.', text: 'The Saturday group rides are so fun! Great way to meet fellow cyclists and explore Roseville trails.', rating: 5, date: '3 weeks ago' },
    ],
    highlights: ['Expert Fitting', 'Group Rides', 'Trail Maps'],
  },
];
